import {
  toPercentNumber,
  tryTransNumber,
  sentimentNumber,
} from '../../render-helper';

const getChannelAndName =
  (type: 'name' | 'channel', splitText = '#_to_#') =>
    (item, key) => {
      const name = item[key];
      if (splitText && name.includes(splitText)) {
        const [channel, newName] = name.split(splitText);
        return type === 'name' ? '#' + newName : channel;
      }
      return '#' + name;
    };

export default function (params: any) {
  const { hideSentimentRating } = params;
  let commonColumns = [
    {
      header: 'Hashtag',
      render: 'name',
      renderHelper: [getChannelAndName('name', params.splitText)],
    },
    { header: 'Mentions', render: 'mentions', renderHelper: [tryTransNumber] },
    // {
    //   header: 'Mentions Percent%',
    //   render: 'mentions_percentage',
    //   renderHelper: [toPercentNumber()],
    //   numFmt: '0.00%',
    // },
    {
      header: 'Mentions DOD%',
      render: 'mentions_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
    { header: 'Total Potential Impressions', render: 'followers', renderHelper: [tryTransNumber] },
    {
      header: 'Total Potential Impressions DOD%',
      render: 'followers_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
    { header: 'Views', render: 'views', renderHelper: [tryTransNumber] },
    {
      header: 'Views DOD%',
      render: 'views_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
    {
      header: 'Non-negative%',
      render: 'non_negative_ratio',
      renderHelper: [toPercentNumber(false)],
      numFmt: '0.00%',
    },
    // {
    //   header: 'Non-negative Percent%',
    //   render: 'non_negative_ratio_percentage',
    //   renderHelper: [toPercentNumber()],
    //   numFmt: '0.00%',
    // },
    {
      header: 'Non-negative DOD%',
      render: 'non_negative_ratio_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
    {
      header: 'Sentiment',
      render: 'sentiment',
      renderHelper: [sentimentNumber],
      numFmt: ['0.00'],
    },
    // {
    //   header: 'Sentiment Percent%',
    //   render: 'sentiment_percentage',
    //   renderHelper: [toPercentNumber()],
    //   numFmt: '0.00%',
    // },
    {
      header: 'Sentiment DOD%',
      render: 'sentiment_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
    {
      header: 'Negative',
      render: 'negative_mentions',
      renderHelper: [tryTransNumber],
    },
    // {
    //   header: 'Negative Percent%',
    //   render: 'negative_mentions_percentage',
    //   renderHelper: [toPercentNumber()],
    //   numFmt: '0.00%',
    // },
    {
      header: 'Negative DOD%',
      render: 'negative_mentions_than',
      renderHelper: [toPercentNumber()],
      numFmt: '0.00%',
    },
  ];

  let by_channel = params.by_channel;

  if (by_channel) {
    commonColumns.splice(1, 0, {
      header: 'Channel',
      render: 'name',
      renderHelper: [getChannelAndName('channel', params.splitText)],
    });
  }

  if (hideSentimentRating) {
    commonColumns = commonColumns.filter(
      (item) =>
        ![
          'non_negative_ratio',
          'non_negative_ratio_percentage',
          'non_negative_ratio_than',
          'sentiment',
          'sentiment_percentage',
          'sentiment_than',
          'negative_mentions',
          'negative_mentions_percentage',
          'negative_mentions_than',
        ].includes(item.render),
    );
  }

  return commonColumns;
}
